import React from 'react';
import Bin from './Bin';
const BinXS = ({ color, ...props }) => (React.createElement(Bin, Object.assign({ color: color, size: 16 }, props)));
BinXS.displayName = 'BinXS'; // Fix for tsc
export default BinXS;
//# sourceMappingURL=BinXS.js.map